<script lang="ts">
  import { Button } from '@agapi/ui/button';
  import { storyblokEditable } from '@storyblok/svelte';
  import type { ButtonStoryblokProps } from './button.types';

  const { blok }: ButtonStoryblokProps = $props();

  const href = $derived(blok.link?.cached_url || '#');
</script>

<Button
  use={[[storyblokEditable,blok]]}
  variant={blok.variant}
  size={blok.size}
  {href}
>
  {blok.label}
</Button>